import {
  PRODUCTION_FACEBOOK_APP_ID,
  DEVELOPMENT_FACEBOOK_APP_ID
} from '../../../constants';
import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { decorateIntlMessages } from '../rosetta_formatted_message';
import SocialIcon from '../social_icon';
import renderClientSideOnly from '../../hocs/renderClientSideOnly';
import {find, some, isEmpty, get} from 'lodash';
import PropTypes from 'prop-types';
import { stringify } from 'querystring';
import { forceHTTP } from '../../../utils/url';
import { onProductionHostname } from '../../../utils/env';
import { FaIcon } from '../fa_icons';

const i18nMessages = decorateIntlMessages(__filename, defineMessages({
  paid_description: {
    id: 'paid_description',
    description: 'Share description with the translation for "Paid Content" for social sharing on sponsored stories',
    defaultMessage: '(Paid Content) {shareDescription}'
  },
  share_button_title: {
    id: 'share_button_title',
    description: 'Share button title attribute content (Share on Facebook)',
    defaultMessage: 'Share on Facebook'
  }
}));

export const FacebookSocialIcon = (props, context) => {
  const { parentClass, opener_images, asset_main: { src_full },
    url_full, meta_description, meta_title, social_title,
    sanitizedTitle, excerpt_truncated_325, enableAdTextForShares,
    intl
  } = props;
  const facebookOpener = find(opener_images, { label: 'FACEBOOK' });
  const shareDescription = meta_description || excerpt_truncated_325;
  const hostname = get(context, 'location.hostname');
  const app_id = String(
    onProductionHostname(hostname)
      ? PRODUCTION_FACEBOOK_APP_ID
      : DEVELOPMENT_FACEBOOK_APP_ID
  );
  const socialURLParams = {
    app_id,
    display: 'popup',
    link: url_full && `${url_full}?utm_source=facebook&utm_medium=facebook_share`,
    picture: forceHTTP(get(facebookOpener, 'asset.src.full') || src_full),
    description: enableAdTextForShares
      ? intl.formatMessage(i18nMessages.paid_description, { shareDescription })
      : shareDescription,
    name: social_title || meta_title || sanitizedTitle
  };

  if (some(socialURLParams, isEmpty)) {
    return null;
  }

  const querystring = stringify(socialURLParams);
  const socialURL = `https://www.facebook.com/dialog/feed?${querystring}`;

  return (
    <SocialIcon
      parentClass={parentClass}
      url_full={url_full}
      category="Facebook"
      action="Post"
      socialURL={socialURL}
      faClassName="facebook"
      title={intl.formatMessage(i18nMessages.share_button_title)}
    />
  );
};

const decorator = renderClientSideOnly({
  placeholder: () => (
    <FaIcon iconName="facebook" tagName="button" />
  )
});
export default decorator(injectIntl(FacebookSocialIcon));

FacebookSocialIcon.propTypes = {
  asset_main: PropTypes.shape({
    src_full: PropTypes.string
  }).isRequired,
  opener_images: PropTypes.arrayOf(PropTypes.shape({
    asset: PropTypes.shape({
      src: PropTypes.shape({
        full: PropTypes.string
      })
    })
  })).isRequired,
  url_full: PropTypes.string.isRequired,
  sanitizedTitle: PropTypes.string.isRequired,
  excerpt_truncated_325: PropTypes.string.isRequired,
  meta_description: PropTypes.string,
  meta_title: PropTypes.string,
  social_title: PropTypes.string,
  enableAdTextForShares: PropTypes.bool,
  intl: PropTypes.object.isRequired,
  parentClass: PropTypes.string
};

FacebookSocialIcon.contextTypes = {
  location: PropTypes.object
};

FacebookSocialIcon.defaultProps = {
  asset_main: { src_full: '' },
  opener_images: [{
    asset: {
      src: {
        full: ''
      }
    }
  }],
  url_full: '',
  sanitizedTitle: '',
  excerpt_truncated_325: '',
  enableAdTextForShares: false
};
